export const postedByDateTime = 'DD/MM/YYYY [at] HH:mm';
export const eventsDateTime = 'DD MMMM YYYY HH:mm';
